"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSegmentIdentify = exports.identify = exports.track = exports.trackVisit = void 0;
var react_1 = require("react");
var MAX_WAIT_MS = 1000;
var flushPendingAnalyticsCalls = function () {
    if (!window._pending_segment_calls ||
        window._pending_segment_calls.length === 0)
        return;
    if (!window.analytics) {
        setTimeout(flushPendingAnalyticsCalls, 10);
        return;
    }
    var toCall = window._pending_segment_calls;
    window._pending_segment_calls = [];
    toCall.map(function (args) {
        return window.analytics &&
            window.analytics[args[0]](args[1], args[2], {}, args[3]);
    });
};
var analyticsCall = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var callPromise = new Promise(function (resolve) {
        if (!window.analytics) {
            if (!window._pending_segment_calls)
                window._pending_segment_calls = [];
            window._pending_segment_calls.push(__spreadArray(__spreadArray([], args, true), [resolve], false));
            flushPendingAnalyticsCalls();
            return;
        }
        window.analytics[args[0]](args[1], args[2], {}, resolve);
    });
    var timeoutPromise = new Promise(function (resolve) {
        setTimeout(resolve, MAX_WAIT_MS);
    });
    return Promise.race([callPromise, timeoutPromise]);
};
var trackVisit = function (pageName, props) {
    return analyticsCall('page', pageName, props);
};
exports.trackVisit = trackVisit;
var track = function (_a) {
    var event = _a.event, _b = _a.properties, properties = _b === void 0 ? {} : _b;
    return analyticsCall('track', event, properties);
};
exports.track = track;
var identify = function (userId, traits) {
    return analyticsCall('identify', userId, traits);
};
exports.identify = identify;
var useSegmentIdentify = function (user) {
    (0, react_1.useEffect)(function () {
        if (!user || window._segment_identified)
            return;
        // Do not need to add extra user info, Zoltar backend takes care of filling
        // out. This is to allow track calls to fire indepently of any concerns
        // around identity
        (0, exports.identify)(user.id, { email: user.email });
        window._segment_identified = true;
    }, [user]);
    return null;
};
exports.useSegmentIdentify = useSegmentIdentify;
//# sourceMappingURL=tracking.js.map